import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export class Slider extends Component {
  constructor(props) {
    super(props);
    this.position = 0;
    this.slidesData = [];
    this.reference = 'slider-' + Math.floor(Math.random() * 100 + 1);
  }

  componentDidMount() {
    this.fetchSliderData();
    // Refresh slider data every 30 min
    this.refreshInterval = setInterval(this.fetchSliderData, 30 * 60 * 1000);
    // Start auto-play
    this.startInterval();
  }

  componentWillUnmount() {
    clearInterval(this.refreshInterval);
    clearInterval(this.interval); // cleanup autoplay
  }

  fetchSliderData = () => {
    const url = process.env.REACT_APP_SLIDER_JSON + '?ts=' + Date.now();
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        this.slidesData = data;
        this.forceUpdate(); // update slider
      })
      .catch((error) => console.error('Failed to load slider images:', error));
  };

  move = (direction) => {
    if (direction === '<') {
      this.position = this.position - 1;
    } else if (direction === '>') {
      this.position = this.position + 1;
    } else {
      this.position = direction;
    }

    if (this.position < 0) {
      this.position = this.slidesData.length - 1;
    } else if (this.position >= this.slidesData.length) {
      this.position = 0;
    }

    // ✅ Only force re-render, let CSS handle transition
    this.forceUpdate();
  };

  stopInterval = () => {
    clearInterval(this.interval);
  };

  startInterval = () => {
    this.interval = setInterval(() => {
      this.move('>');
    }, 5000);
  };

  slides() {
    return this.slidesData.map((item, index) => (
      <div
        key={index}
        className={`slide ${this.position === index ? 'active' : ''}`}
        style={{ width: 100 / this.slidesData.length + '%' }}
      >
        <picture>
          <source media='(min-width: 768px)' srcSet={item.desktop} />
          <source media='(max-width: 767px)' srcSet={item.mobile} />
          <img
            src={`${item.desktop}?v=${Date.now()}`}
            alt={`slide-${index}`}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            loading='lazy'
          />
        </picture>
      </div>
    ));
  }

  bullets() {
    return this.slidesData.map((_, index) => (
      <span
        key={index}
        className={this.position === index ? 'bullet active' : 'bullet'}
        onClick={() => this.move(index)}
      ></span>
    ));
  }

  render() {
    let slides = this.slides();
    let bullets = this.bullets();

    return (
      <div
        className='slider'
        onMouseEnter={this.stopInterval}
        onMouseLeave={this.startInterval}
      >
        <div
          className='sliderWrap'
          ref={this.reference}
          style={{
            width: slides.length * 100 + '%',
            display: 'flex',
            transition: 'left 0.5s',
            position: 'relative',
            left: `-${this.position * 100}%`,
          }}
        >
          {slides}
        </div>
        <div className='bullets'>{bullets}</div>
      </div>
    );
  }
}
